<template lang="pug">
	.app-core--image-editor(:style="{ '--url': dataUri ? `url('${dataUri}')` : '#fff', '--size': `${size}`}")
		.image(@click="$refs.uplaoder.showPopup()")
		.upload-icon.flex-row.center.align-center(:class="{ 'no-image': !dataUri }")
			fas(icon="image")
		FileUploader(ref="uplaoder", :text="$tCaption('Upload Image')", icon="fas fa-cloud-upload-alt", :accept="['.png', '.jpg', '.jpeg']" :multiple="false", :isUIHidden="true", 
			@file-selected="onImageSelected", @upload="onImageChange", :popupConfig="{ height: 520, width: 520 }", @popup="imageData = null"
		)
			.flex-row.align-center(v-if="imageData", slot="bottom-content")
				VueCropper.user-profile.cropper-element(ref="cropper", :aspectRatio="1", :src="imageData")
</template>

<script>
	import VueTypes from 'vue-types';
	import VueCropper from 'vue-cropperjs';
	import 'cropperjs/dist/cropper.css';
	import FileUploader from 'app-core/FileUploader.vue';

	export default {
		name: 'watcher',
		props: {
			objectId: VueTypes.string.def(null),
			objectType: VueTypes.number.def(-1),
			url: VueTypes.string.def(''),
			size: VueTypes.string.def('60px'),
			rounded: VueTypes.bool.def(false),
			fieldName: VueTypes.any.def(null),
			cropSizes: VueTypes.any.def([320, 320])
		},
		components: {VueCropper, FileUploader},
		data() {
			return {
				imageData: null,
				fileName: null,
				croppedImage: null
			};
		},
		computed: {
			dataUri() {
				return this.croppedImage || this.url;
			}
		},
		watch: {
			url() {
				this.clearImage();
			},
			objectId() {
				this.clearImage();
			},
			fieldName() {
				this.clearImage();
			}
		},
		mounted() {
			if (__DEBUG__)
				window.imageEditor = this;
		},
		destroyed() {
			delete this.$needPostSave;
		},
		methods: {
			clearImage() {
				setImmediate(() => this.croppedImage = null);
			},
			onImageSelected(v) {
				this.imageData = null;
				var fr = new FileReader;
				fr.readAsDataURL(v[0]);
				fr.onloadend = () => {
					this.imageData = fr.result;
					this.fileName = v[0].name;
				};
			},
			onImageChange() {
				const dataUri = `${this.$refs.cropper.getCroppedCanvas({ width: this.cropSizes[0], height: this.cropSizes[1] }).toDataURL()}`;
				this.croppedImage = dataUri;
				this.$emit('change', this.croppedImage);

				if (!this.objectId) {
					this.$needPostSave = true;
					return;
				}
				this.$needPostSave = false;
				this.save();
			},
			save(payload) {
				const base64 = this.croppedImage;
				const img = base64?.split('base64,')[1];
				this.$needPostSave = false;
				return this.$Data.postExternalApi('Service/SetObjectImage', {
					ObjectId: this.objectId,
					ObjectType: this.objectType,
					Base64Content: img,
					FileExtension: this.fileName?.split('.').slice(-1)[0],
					FieldName: this.fieldName,
					...(payload || {})
				}).then(r => {
					if (__DEBUG__)
						console.debug('Image uploaded', { r });
					return base64;
				});
			},
			async ensureSaved(payload) {
				if (__DEBUG__)
					console.debug('Ensure saved', { payload });
				if (this.$needPostSave) return this.save(payload);
				return this.croppedImage || this.url;
			}
		}
	};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";
	.app-core--image-editor {
		position: relative;
		.image {
			width: var(--size);
			height: var(--size);
			background: var(--url);
			background-position: center;
			background-size: cover;
			border-radius: 4px;
			margin: 10px;
			cursor: pointer;

			&.rounded {
				border-radius: var(--size);
			}
		}

		.upload-icon {
			opacity: 0;
			pointer-events: none;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translateX(-50%)	translateY(-50%);
			transition: 0.3s;
			font-size: calc(var(--size) / 8);
			background: rgba(255,255,255,0.9);
			padding: 10px;
			border-radius: var(--size);
			width: 35%;
			height: 35%;
			box-shadow: 0px 0px 32px 0px rgba(34, 60, 80, 0.2);
			color: #333;

			&.no-image {
				opacity: 1;
				box-shadow: none;
			}
		}

		&:hover {
			.upload-icon {
				opacity: 1;
				color: $base-accent;
			}
		}
	}
</style>